module.exports = __webpack_public_path__ + "static/media/leader_logo.a1f7df66.gif";